import React, { useState } from "react";
import {  useNavigate } from "react-router-dom";

export default function ProfileSettings() {
  const [profileImg, setProfileImg] = useState(
    "https://signalmax.springsoftit.com/demo/asset/images/placeholder.png"
  );
  const [telegramgroup, setTelegramgroup] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [telegramUsername, setTelegramUsername] = useState("");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  // const [city, setCity] = useState("");
  // const [zipCode, setZipCode] = useState("");
  // const userId = localStorage.getItem('id')
  const navigate = useNavigate();
  let uploadImg = () => {
    document.getElementById("addImg").click();
  };
  let changeImg = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setProfileImg(reader.result);
    };
    reader.readAsDataURL(file);
    console.log(file);
  };

  // const updateProfile = () => {
  //   const myHeaders = new Headers();

  //   myHeaders.apennd("Content-Type", "applicattion/json");

  //   let body = JSON.stringify({
  //     telegramgroup,
  //     phoneNumber,
  //     telegramUsername,
  //     email,
  //   });
  //   let requestOption={
  //     method: "POST",
  //     headers: myHeaders,
  //     body,
  //     redirect: "follow",
  //   }
  //   fetch(`http://localhost:4000/api/profile/${userId}`,requestOption)
  //   .then((response)=>response.json())
  //   .then((data)=>{
  //     console.log(data)
  //   })
  //   .catch((err)=>{
  //     console.log(err.message)
  //   })
  // };

  return (
    <div className="w-full pt-10">
      <div className="w-full min-h-[50%] ">
        <nav className="border-1 flex justify-between w-full p-4 border border-gray-400 rounded-tl-md rounded-tr-md ">
          <p className="self-start">Profile Settings</p>
          <button
            className="bg-[#A7FF35] p-2 rounded-xl text-black w-48"
            onClick={() => navigate("/dashboard/profile/change/password")}
          >
            change password
          </button>
        </nav>
        <section className="w-full border border-t-0 border-gray-400 p-9 flex justify-between flex-wrap gap-12 lg:gap-0 rounded-bl-md rounded-br-md ">
          <div className="lg:w-[30%] flex flex-col justify-center items-center">
            <img src={profileImg} alt="Profile" className="w-[50%]  mb-4 " />
            <input
              type="file"
              accept=".jpg,.png,"
              id="addImg"
              className="hidden"
              onChange={(e) => changeImg(e)}
            />
            <button
              onClick={uploadImg}
              className="bg-[#A7FF35] p-2 rounded-xl text-black w-48"
            >
              Upload Image
            </button>
          </div>
          <div className="lg:w-[70%] flex flex-col  self-center">
            <form action="" className="flex flex-wrap justify-center gap-10">
              <span className="flex flex-col lg:lg:w-[47%]">
                <label htmlFor="">Telegram username</label>
                <input
                  type="text"
                  className="w-full py-[10px] px-[15px] rounded-md bg-gray-200  text-black "
                  value={telegramUsername}
                  onChange={(e) => setTelegramUsername(e.target.value)}
                />
              </span>

              <span className="flex flex-col lg:w-[47%]">
                <label htmlFor="">Telegram Group ID</label>
                <input
                  type="text"
                  className="w-full py-[10px] px-[15px] rounded-md bg-gray-200  text-black "
                  value={telegramgroup}
                  onChange={(e) => setTelegramgroup(e.target.value)}
                />
              </span>

              <span className="flex flex-col lg:w-[47%]">
                <label htmlFor="">Email Address</label>
                <input
                  type="email"
                  className="w-full py-[10px] px-[15px] rounded-md bg-gray-200  text-black "
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </span>

              <span className="flex flex-col lg:w-[47%]">
                <label htmlFor="">Phone</label>
                <input
                  type="tel"
                  className="w-full py-[10px] px-[15px] rounded-md bg-gray-200  text-black "
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
              </span>

             <span className="flex flex-col lg:w-[47%]">
                <label htmlFor="">Username</label>
                <input
                  type="text"
                  className="w-full py-[10px] px-[15px] rounded-md bg-gray-200  text-black "
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </span>
            </form>
            <button className="bg-[#A7FF35] p-4 mt-20 self-center rounded-xl text-black w-[30%]">
                update
              </button>
          </div>
        </section>
      </div>
    </div>
  );
}
